module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0006.e3f7db99.jpg";